<h1>Microsoft Login Redirect</h1>
<p>
  TenantGuid: {{tenantGuid}}
</p>
<p>
  TenantGuid: {{adminConsent}}
</p>
